export const ConfirmNativeHost = () => null;

export const onConfirmNative = ({ title, text, requireText = null, input = null }) => {
    const MESSAGE = text ? `${title}\n\n${text}` : title;

    if (input) {
        const VALUE = window.prompt(`${MESSAGE}\n\n${input.label || 'Codigo de seguridad'}:`);
        const TEXT = String(VALUE ?? '').trim();
        if (!TEXT) return Promise.resolve(null);
        if (input.length && TEXT.length !== Number(input.length)) return Promise.resolve(null);
        if (input.pattern) {
            try { if (!new RegExp(input.pattern).test(TEXT)) return Promise.resolve(null); }
            catch { /* fallback */ }
        }
        return Promise.resolve(TEXT);
    }

    if (requireText) {
        const TYPED = window.prompt(`${MESSAGE}\n\nEscribi "${requireText}" para confirmar:`);
        return Promise.resolve(String(TYPED ?? '').trim() === String(requireText).trim());
    }

    return Promise.resolve(window.confirm(MESSAGE));
};
